export default __webpack_public_path__ + "static/media/sparck-logo-colored.8a416c19.png";